import classNames from 'classnames';
import React from 'react';
import { getCountryName, getFlagEmoji } from '../utils';

type CountryEmojisProps = React.HTMLAttributes<HTMLDivElement> & {
  countryIds: string[];
};

const CountryEmojis: React.FC<CountryEmojisProps> = ({ countryIds, className, ...props }) => {
  if (!countryIds?.length) {
    return null;
  }
  return (
    <span className={classNames('inline-flex gap-1', className)} {...props}>
      {countryIds.map((countryId) => (
        <span key={countryId} title={getCountryName(countryId)}>
          {getFlagEmoji(countryId)}
        </span>
      ))}
    </span>
  );
};

export default CountryEmojis;
